/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\OtherSVG\MailSVG.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 25th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 25th 2023 5:13:46 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function MailSVG(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} width={props.width} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
            <path d="M68.47,61.81c-.01,1.64-1.34,2.97-2.98,2.98H11.37c-1.65,0-2.98-1.34-2.98-2.98v-3.03H62.46V23.64l-24.03,21.63L8.39,18.23v-4.51c0-1.66,1.34-3,3-3h54.07c1.66,0,3,1.34,3,3V61.81ZM15.7,16.73l22.73,20.46,22.73-20.46H15.7ZM2.38,46.77H26.41v6.01H2.38v-6.01Zm0-15.02h15.02v6.01H2.38v-6.01Z"/>
        </svg>
    );
}

export default MailSVG;
